import FullWidthLayout from "@/layouts/FullWidthLayout";
import VendorsTable from "kinnect-front/FacilityMaintenance/Vendors/VendorsTable";
import { FacilityMaintenanceVendor } from "kinnect-models";
import { FetchesData, Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import { VCard, VSheet } from "vuetify/lib";

export default {
	name: "FacilityMaintenanceVendorsPage",

	metaInfo: { title: "Facility Maintenance - Vendors" },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		search: "",
		vendors: []
	} ),

	computed: {
		toolbarActions() {
			if ( this.$can( "add_facility_maintenance_vendors" ) ) {
				return {
					icon: "add_circle",
					text: "Add Vendor",
					to: { name: "facilityMaintenanceVendorAdd" },
					tooltip: "Add a new vendor"
				};
			}
		}
	},

	methods: {
		async fetchVendors() {
			this.vendors = await FacilityMaintenanceVendor.get();
		},

		async fetch() {
			await this.fetchVendors();
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<VendorsTable
					items={this.vendors}
					loading={this.$wait.is( "get vendors" )}
					search={this.search}
				></VendorsTable>
			</VCard>
		</FullWidthLayout>;
	}
};
